import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import React, { useCallback, useMemo, useRef, useState } from 'react';
import config from 'utils/config';
import MindsetUploadMeetingTranscriptModal from 'components/MindsetUploadMeetingTranscriptModal';
import { updateExtraSituationalAwarenessContext } from '../situationalAwareness/useExtraSituationalAwarenessContext';
import { getAgentElement } from '../getAgentElement';
import { sendMessageToThread } from '../threads/sendMessageToThread';
import { jsx as _jsx } from "react/jsx-runtime";
export var defaultHelixMindsetUploadTranscriptToolDescription = ['UI ACTION: Opens a modal for uploading meeting conversation text for analysis.', 'MUST TRIGGER when the user wants Helix to process/analyse/summarise a meeting transcript and the transcript content is not already provided inline.', 'Trigger examples: “process a meeting transcript”, “analyse this call”, “summarise my meeting transcript”, “upload/attach/import/share transcript”, “I have a .vtt/.srt/.docx transcript—can you review it?”, “turn this transcript into action items/decisions/minutes”.', 'Do NOT trigger for: questions about how to download/get a transcript (“Where do I download a Teams transcript?”, “How do I get a transcript from Zoom?”), general questions with no transcript being provided (“How should I structure meeting minutes?”), or when the user explicitly says not to open anything.'].join(' ');
var description = config.helixMindsetUploadTranscriptToolDescription || defaultHelixMindsetUploadTranscriptToolDescription;
export var defaultUploadTranscriptModalClosedNoTranscriptMsg = "The user closed the meeting transcript upload modal without providing a file. They may not have a transcript available. Ask if they'd like guidance on getting one from their meeting platform, or whether they'd like to proceed without it.";
var closedWithoutTranscriptMsg = config.helixMindsetUploadTranscriptToolModalClosedNoTranscript || defaultUploadTranscriptModalClosedNoTranscriptMsg;
export function useMindsetUploadTranscriptModalTool(containerId) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var hasUploadedRef = useRef(false);
  var tool = useMemo(function () {
    return {
      name: 'open_meeting_transcript_file_upload_modal',
      description: description,
      runningDescription: 'Opening upload transcript modal',
      completedDescription: 'Opened upload transcript modal',
      parameters: {
        type: 'object',
        properties: {}
      },
      handler: function () {
        var _handler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                hasUploadedRef.current = false;
                setIsOpen(true);
                return _context.abrupt("return", {
                  success: true
                });
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function handler() {
          return _handler.apply(this, arguments);
        }
        return handler;
      }()
    };
  }, []);
  var onClose = useCallback(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      match_failed_options = _ref.match_failed_options;
    setIsOpen(false);
    if (match_failed_options) {
      sendMessageToThread(getAgentElement(containerId), "The transcript was uploaded but a match for the user could not be found. \n\t\t\t\t\tThe list of users in the transcript is ".concat(match_failed_options.speakers, ". \n\t\t\t\t\tAsk the user to select which user they are and then you can run the analysis using the analyze_existing_transcript_file pageTool with that selected speaker, the file ID which is ").concat(match_failed_options.fileId).concat(match_failed_options.s3FilePath ? ", and the file path which is ".concat(match_failed_options.s3FilePath) : '', "."));
      return;
    }
    if (!hasUploadedRef.current) {
      sendMessageToThread(getAgentElement(containerId), closedWithoutTranscriptMsg);
    }
  }, [containerId]);
  var onUpload = useCallback(function (file, initialAnalysis) {
    var _getAgentElement, _getAgentElement$send;
    hasUploadedRef.current = true;
    updateExtraSituationalAwarenessContext({
      uploadedTranscriptFileName: file.name,
      transcriptInitialAnalysis: JSON.stringify(initialAnalysis)
    });
    (_getAgentElement = getAgentElement(containerId)) === null || _getAgentElement === void 0 || (_getAgentElement$send = _getAgentElement.sendMessage) === null || _getAgentElement$send === void 0 || _getAgentElement$send.call(_getAgentElement, config.helixMindsetSkillSummaryPrompt, {
      silent: true
    });
  }, [containerId]);
  var modal = isOpen ? /*#__PURE__*/_jsx(MindsetUploadMeetingTranscriptModal, {
    onClose: onClose,
    onUpload: onUpload
  }) : null;
  return {
    tool: tool,
    modal: modal
  };
}